import { Link } from 'react-router-dom'
import { Card } from '@/components/ui/Card'

export function DashboardsHomePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-[var(--text-primary)]">Dashboards</h1>
        <p className="text-sm text-[var(--text-muted)] mt-1">Choose a dashboard to view.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/dashboard/presales/performance" className="block">
          <Card className="p-4 hover:bg-[var(--bg-tertiary)] transition-colors">
            <div className="text-sm font-semibold text-[var(--text-primary)]">Presales</div>
            <div className="text-xs text-[var(--text-muted)] mt-1">Pipeline and presales activity overview.</div>
          </Card>
        </Link>
        <Link to="/dashboard/implementations" className="block">
          <Card className="p-4 hover:bg-[var(--bg-tertiary)] transition-colors">
            <div className="text-sm font-semibold text-[var(--text-primary)]">Implementations</div>
            <div className="text-xs text-[var(--text-muted)] mt-1">Implementation pipeline and delivery activity overview.</div>
          </Card>
        </Link>
      </div>
    </div>
  )
}
